import React, { useState } from 'react';
import { ScrollArea } from '../ui/scroll-area';
import WorkOrderTreeItem from './WorkOrderTreeItem';
import { Loader2, ClipboardList, History } from 'lucide-react';

function ScheduleSidebar({ orders, isLoading, onBatchAssign, onSplitStep, historicalOrders, historicalLoading }) {
  const [activeTab, setActiveTab] = useState('pending');

  const displayOrders = activeTab === 'pending' ? orders : (historicalOrders || []);
  const displayLoading = activeTab === 'pending' ? isLoading : historicalLoading;

  const totalSteps = displayOrders.reduce(
    (sum, order) =>
      sum +
      order.items?.reduce(
        (isum, item) => isum + (item.steps?.filter((s) => !s.is_subcontracted).length || 0),
        0
      ),
    0
  );

  return (
    <div className="w-[340px] flex flex-col border-r border-gray-200 bg-gray-50 shrink-0">
      {/* Tabs */}
      <div className="flex border-b border-gray-200 bg-white">
        <button
          className={`flex-1 flex items-center justify-center gap-1.5 px-3 py-2 text-xs font-medium transition-colors ${
            activeTab === 'pending'
              ? 'text-blue-700 border-b-2 border-blue-500 bg-blue-50/50'
              : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
          }`}
          onClick={() => setActiveTab('pending')}
        >
          <ClipboardList className="h-3.5 w-3.5" />
          待分配工序
        </button>
        <button
          className={`flex-1 flex items-center justify-center gap-1.5 px-3 py-2 text-xs font-medium transition-colors ${
            activeTab === 'historical'
              ? 'text-blue-700 border-b-2 border-blue-500 bg-blue-50/50'
              : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
          }`}
          onClick={() => setActiveTab('historical')}
        >
          <History className="h-3.5 w-3.5" />
          历史订单
        </button>
      </div>

      <div className="px-3 py-2 border-b border-gray-200 bg-white">
        <div className="flex items-center justify-between">
          <span className="text-xs text-gray-500">
            {activeTab === 'pending' ? '在产工单' : '全部历史工单'}
          </span>
          <span className="text-xs text-gray-500">
            {displayOrders.length}个工单 · {totalSteps}个工序
          </span>
        </div>
      </div>

      <ScrollArea className="flex-1 px-2 py-2">
        {displayLoading ? (
          <div className="flex items-center justify-center py-8">
            <Loader2 className="h-5 w-5 animate-spin text-gray-400" />
            <span className="ml-2 text-sm text-gray-500">加载中...</span>
          </div>
        ) : displayOrders.length === 0 ? (
          <div className="text-center py-8 text-sm text-gray-400">
            {activeTab === 'pending' ? '暂无待分配工序' : '暂无历史订单可迁移'}
          </div>
        ) : (
          displayOrders.map((order) => (
            <WorkOrderTreeItem
              key={order.production_order_id}
              order={order}
              onBatchAssign={onBatchAssign}
              onSplitStep={onSplitStep}
              isHistorical={activeTab === 'historical'}
            />
          ))
        )}
      </ScrollArea>
    </div>
  );
}

export default ScheduleSidebar;
